var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconExpandLatest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 11,
    viewBox: "0 0 30 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.01 10.831H5.05C2.3 10.831.06 8.495.06 5.623.06 2.752 2.3.415 5.05.415h19.96C27.761.415 30 2.752 30 5.623c0 2.872-2.239 5.208-4.99 5.208zM5.05 3.887c-.916 0-1.663.78-1.663 1.736 0 .957.747 1.736 1.663 1.736h19.96c.917 0 1.663-.78 1.663-1.736s-.746-1.736-1.663-1.736H5.05z",
    fill: "#004FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExpandLatest);
export default __webpack_public_path__ + "static/media/icon-expand_latest.61559b691402e09836ed52390a071057.svg";
export { ForwardRef as ReactComponent };